/**
 * Location utility functions for formatting and normalizing location names
 */

/**
 * Normalize location name by removing diacritics and extracting city name only
 * @param {string} name - Location name (e.g., "Chāmpāhāti, IN")
 * @returns {string} - Normalized city name (e.g., "Champahati")
 */
export function normalizeLocationName(name) {
  if (!name) return 'Current Location'
  
  // Remove diacritics (accented characters)
  const normalized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  
  // Split by comma and take only the city part (first part)
  const parts = normalized.split(',')
  const cityName = parts[0].trim()
  
  return cityName
}

/**
 * Format location for display (city only, no country code)
 * @param {Object} weather - Weather object from OpenWeatherMap
 * @returns {string} - Formatted location name
 */
export function formatLocationFromWeather(weather) {
  if (!weather || !weather.name) return 'Current Location'
  
  const locationString = weather.name
  return normalizeLocationName(locationString)
}

/**
 * Extract clean city name from cached weather data
 * @param {Object} cachedData - Cached weather data object
 * @returns {string} - Clean city name
 */
export function getCityFromCache(cachedData) {
  if (!cachedData) return 'Current Location'
  
  // Try to get from weather data first
  if (cachedData.weather && cachedData.weather.name) {
    return normalizeLocationName(cachedData.weather.name)
  }
  
  // Fallback to cached location string
  if (cachedData.location) {
    return normalizeLocationName(cachedData.location)
  }
  
  return 'Current Location'
}
